/**
 * Resolve product image URLs for storefront img tags.
 * Handles absolute external URLs and same-origin API image paths.
 */
import type { ProductImage } from '@/types'

const API_BASE = import.meta.env.VITE_API_URL ?? '/api/v1'

function getApiOrigin(): string {
  if (!API_BASE.startsWith('http')) {
    return ''
  }

  try {
    return new URL(API_BASE).origin
  } catch {
    return ''
  }
}

export function resolveProductImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) {
    return null
  }

  const trimmed = url.trim()

  if (/^(https?:|data:|blob:)/i.test(trimmed)) {
    return trimmed
  }

  const origin = getApiOrigin()

  if (trimmed.startsWith('/')) {
    return origin ? `${origin}${trimmed}` : trimmed
  }

  return origin ? `${origin}/${trimmed}` : `/${trimmed}`
}

export function getProductImageSrc(
  product: { images?: ProductImage[] } | null | undefined,
): string | null {
  return resolveProductImageUrl(product?.images?.[0]?.url)
}
